(function () {
  'use strict';

  const cfg = window.aiGeneratorConfig || {};
  const API_BASE = cfg.apiBase || '';
  const CUSTOMER_ID = cfg.customerId || null;
  const CUSTOMER_EMAIL = cfg.customerEmail || null;
  const VARIANT_MAP = cfg.variantMap || {};
  const CREDIT_VARIANT_ID = cfg.creditVariantId || null;
  const PRODUCT_TITLE = cfg.productTitle || 'Magnet Set';
  const PRESETS = cfg.presets || { watercolor: { label: 'Watercolor', emoji: '🎨' } };

  let selectedFiles = [];
  let selectedVariantId = null;
  let selectedCount = 6;
  let generatedImages = [];
  let sessionToken = null;
  let selectedPreset = 'watercolor';

  const uploadZone = document.getElementById('ai-upload-zone');
  const fileInput = document.getElementById('ai-file-input');
  const previewsContainer = document.getElementById('ai-previews');
  const generateBtn = document.getElementById('ai-generate-btn');
  const loadingEl = document.getElementById('ai-loading');
  const loadingCount = document.getElementById('ai-loading-count');
  const resultEl = document.getElementById('ai-result');
  const resultsGrid = document.getElementById('ai-results-grid');
  const resultCount = document.getElementById('ai-result-count');
  const errorEl = document.getElementById('ai-error');
  const errorMsg = document.getElementById('ai-error-msg');
  const tryAgainBtn = document.getElementById('ai-try-again');
  const addToCartBtn = document.getElementById('ai-add-to-cart');
  const uploadCountEl = document.getElementById('ai-upload-count');
  const uploadProgressText = document.getElementById('ai-upload-progress-text');
  const progressFill = document.getElementById('ai-progress-fill');
  const checkoutPrice = document.getElementById('ai-checkout-price');
  const packageBtns = document.querySelectorAll('.ai-package-btn');
  const presetBtns = document.querySelectorAll('.ai-preset-btn');
  const creditUsedEl = document.getElementById('ai-credit-used');
  const uploadSection = document.getElementById('ai-upload-section');
  const myDesignsSection = document.getElementById('ai-my-designs');
  const myDesignsGrid = document.getElementById('ai-my-designs-grid');
  const loadingLabel = document.getElementById('ai-loading-label');
  const resultHeading = document.getElementById('ai-result-heading');

  if (!CUSTOMER_ID) return;

  presetBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      presetBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedPreset = btn.dataset.preset || 'watercolor';
      updateGenerateBtn();
    });
  });

  async function initSession() {
    try {
      const res = await fetch(`${API_BASE}/api/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: CUSTOMER_ID, email: CUSTOMER_EMAIL })
      });
      const data = await res.json();
      if (data.success) {
        sessionToken = data.token;
        await loadCustomerStatus();
      }
    } catch (err) {
      console.error('Session init failed:', err);
    }
  }

  async function loadCustomerStatus() {
    if (!sessionToken) return;
    try {
      const res = await fetch(`${API_BASE}/api/customer/status?token=${sessionToken}`);
      const data = await res.json();
      if (!data.success) return;

      if (data.generations && data.generations.length > 0) {
        renderMyDesigns(data.generations);
      }

      if (!data.hasCredit) {
        showCreditUsed();
      }
    } catch (err) {
      console.error('Failed to load customer status:', err);
    }
  }

  function showCreditUsed() {
    if (creditUsedEl) creditUsedEl.classList.add('active');
    if (uploadSection) uploadSection.style.display = 'none';
    if (generateBtn) generateBtn.style.display = 'none';
  }

  function renderMyDesigns(generations) {
    if (!myDesignsSection || !myDesignsGrid) return;
    myDesignsGrid.innerHTML = '';

    generations.forEach((gen) => {
      const urls = gen.image_urls || [];
      if (urls.length === 0) return;

      const magnetCount = gen.magnet_count || urls.length;
      const batch = document.createElement('div');
      batch.className = 'ai-my-designs-batch';

      const date = new Date(gen.created_at);
      const genPreset = PRESETS[gen.preset] || PRESETS.watercolor;
      const label = document.createElement('div');
      label.className = 'ai-my-designs-batch-label';
      label.textContent = `${genPreset.emoji} ${genPreset.label} · ${magnetCount} Magnets · ${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
      batch.appendChild(label);

      const grid = document.createElement('div');
      grid.className = 'ai-results-grid';

      urls.forEach((url, i) => {
        const card = document.createElement('div');
        card.className = 'ai-result-card';
        card.innerHTML = `
          <div class="ai-result-card-img-wrap">
            <img src="${url}" alt="Magnet ${i + 1}" loading="lazy">
          </div>
          <div class="ai-result-card-footer">
            <span class="ai-result-card-label">Magnet ${i + 1}</span>
            <a href="${url}" download="magnet-${i + 1}.png" class="ai-result-card-download" title="Download">⬇</a>
          </div>
        `;
        grid.appendChild(card);
      });

      batch.appendChild(grid);

      const variantId = VARIANT_MAP[magnetCount] || VARIANT_MAP[Object.keys(VARIANT_MAP)[0]] || null;
      const batchActions = document.createElement('div');
      batchActions.className = 'ai-my-designs-batch-actions';

      const cartBtn = document.createElement('button');
      cartBtn.className = 'ai-btn-primary';
      cartBtn.textContent = `🛒 Add to Cart`;
      cartBtn.addEventListener('click', async () => {
        if (!variantId) {
          alert('Product variant not found. Please contact us for help.');
          return;
        }
        cartBtn.textContent = 'Adding...';
        cartBtn.disabled = true;

        const properties = { 'Style': genPreset.label, 'Magnets': magnetCount.toString() };
        urls.forEach((url, i) => { properties[`Magnet ${i + 1} Art`] = url; });

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1, properties })
          });
          if (res.ok) {
            cartBtn.textContent = 'Added! ✓';
            setTimeout(() => { window.location.href = '/cart'; }, 800);
          } else {
            const err = await res.json();
            throw new Error(err.description || 'Could not add to cart.');
          }
        } catch (err) {
          cartBtn.textContent = `🛒 Add to Cart`;
          cartBtn.disabled = false;
          showError(err.message || 'Could not add to cart. Please try again.');
        }
      });

      batchActions.appendChild(cartBtn);
      batch.appendChild(batchActions);
      myDesignsGrid.appendChild(batch);
    });

    myDesignsSection.classList.add('active');
  }

  packageBtns.forEach(btn => {
    if (btn.disabled) return;
    btn.addEventListener('click', () => {
      packageBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedVariantId = btn.dataset.variantId || null;
      selectedCount = parseInt(btn.dataset.count) || 6;
      if (checkoutPrice) checkoutPrice.textContent = btn.dataset.price || '';
      updateUploadUI();
      if (selectedFiles.length > selectedCount) {
        selectedFiles = selectedFiles.slice(0, selectedCount);
        renderPreviews();
      }
      updateGenerateBtn();
    });
  });

  const firstBtn = document.querySelector('.ai-package-btn.selected');
  if (firstBtn) {
    selectedVariantId = firstBtn.dataset.variantId || null;
    selectedCount = parseInt(firstBtn.dataset.count) || 6;
    if (checkoutPrice) checkoutPrice.textContent = firstBtn.dataset.price || '';
  }

  function updateUploadUI() {
    if (uploadCountEl) uploadCountEl.textContent = selectedCount;
    updateProgress();
  }

  function updateProgress() {
    const count = selectedFiles.length;
    const total = selectedCount;
    if (uploadProgressText) uploadProgressText.textContent = `${count} / ${total} photos uploaded`;
    if (progressFill) progressFill.style.width = `${Math.min((count / total) * 100, 100)}%`;
  }

  if (uploadZone) {
    uploadZone.addEventListener('dragover', (e) => {
      e.preventDefault();
      uploadZone.classList.add('drag-over');
    });
    uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('drag-over'));
    uploadZone.addEventListener('drop', (e) => {
      e.preventDefault();
      uploadZone.classList.remove('drag-over');
      handleFiles(Array.from(e.dataTransfer.files));
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', (e) => {
      handleFiles(Array.from(e.target.files));
      fileInput.value = '';
    });
  }

  function handleFiles(files) {
    const imageFiles = files.filter(f => f.type.startsWith('image/'));
    const remaining = selectedCount - selectedFiles.length;

    if (remaining <= 0) {
      showError(`You already have ${selectedCount} photos. Remove some first or choose a larger package.`);
      return;
    }

    const toAdd = imageFiles.slice(0, remaining);
    toAdd.forEach(file => selectedFiles.push(file));

    if (imageFiles.length > remaining) {
      showError(`Only ${remaining} more photo${remaining === 1 ? '' : 's'} needed. Extra photos were not added.`);
    } else {
      hideError();
    }

    renderPreviews();
    updateProgress();
    updateGenerateBtn();
  }

  function renderPreviews() {
    if (!previewsContainer) return;
    previewsContainer.innerHTML = '';
    selectedFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const thumb = document.createElement('div');
        thumb.className = 'ai-preview-thumb';
        thumb.innerHTML = `
          <img src="${e.target.result}" alt="Photo ${index + 1}">
          <div class="ai-preview-label">Magnet ${index + 1}</div>
          <button class="ai-preview-remove" data-index="${index}" title="Remove">&times;</button>
        `;
        previewsContainer.appendChild(thumb);
        thumb.querySelector('.ai-preview-remove').addEventListener('click', (ev) => {
          ev.stopPropagation();
          selectedFiles.splice(parseInt(ev.target.dataset.index), 1);
          renderPreviews();
          updateProgress();
          updateGenerateBtn();
          hideError();
        });
      };
      reader.readAsDataURL(file);
    });
  }

  function updateGenerateBtn() {
    if (!generateBtn) return;
    const ready = selectedFiles.length === selectedCount;
    const preset = PRESETS[selectedPreset] || PRESETS.watercolor;
    generateBtn.disabled = !ready;
    generateBtn.textContent = ready
      ? `✨ Generate ${selectedCount} ${preset.label} Images`
      : `✨ Generate ${preset.label} Art (${selectedFiles.length}/${selectedCount} photos)`;
  }

  function showError(msg) {
    if (!errorMsg || !errorEl) return;
    errorMsg.textContent = msg;
    errorEl.classList.add('active');
  }

  function hideError() {
    if (errorEl) errorEl.classList.remove('active');
  }

  function showLoading() {
    const preset = PRESETS[selectedPreset] || PRESETS.watercolor;
    if (loadingCount) loadingCount.textContent = selectedCount;
    if (loadingLabel) loadingLabel.textContent = `Creating your ${preset.label} illustrations\u2026`;
    if (loadingEl) loadingEl.classList.add('active');
    if (resultEl) resultEl.classList.remove('active');
    if (generateBtn) generateBtn.disabled = true;
    hideError();
  }

  function hideLoading() {
    if (loadingEl) loadingEl.classList.remove('active');
    updateGenerateBtn();
  }

  if (generateBtn) {
    generateBtn.addEventListener('click', async () => {
      if (selectedFiles.length !== selectedCount) return;
      if (!sessionToken) {
        showError('Session expired. Please refresh the page and try again.');
        return;
      }

      showLoading();

      const formData = new FormData();
      selectedFiles.forEach(file => formData.append('images', file));
      formData.append('preset', selectedPreset);

      try {
        const response = await fetch(`${API_BASE}/api/generate`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${sessionToken}` },
          body: formData
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          if (response.status === 403) {
            hideLoading();
            showCreditUsed();
            return;
          }
          throw new Error(data.error || 'Generation failed. Please try again.');
        }

        generatedImages = data.images;
        const preset = PRESETS[selectedPreset] || PRESETS.watercolor;
        if (resultHeading) resultHeading.textContent = `Your ${preset.label} Art is Ready!`;
        renderResults(data.images);
        hideLoading();
        if (resultEl) resultEl.classList.add('active');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

        showCreditUsed();
        await loadCustomerStatus();

      } catch (err) {
        hideLoading();
        showError(err.message || 'Something went wrong. Please try again.');
      }
    });
  }

  function renderResults(images) {
    if (!resultsGrid) return;
    resultsGrid.innerHTML = '';

    const successful = images.filter(img => img.success);
    if (resultCount) resultCount.textContent = successful.length;

    images.forEach((img, i) => {
      const card = document.createElement('div');
      card.className = 'ai-result-card' + (img.success ? '' : ' ai-result-card--failed');

      if (img.success) {
        const imgSrc = `data:${img.mimeType};base64,${img.data}`;
        card.innerHTML = `
          <div class="ai-result-card-img-wrap">
            <img src="${imgSrc}" alt="Magnet ${i + 1}">
          </div>
          <div class="ai-result-card-footer">
            <span class="ai-result-card-label">Magnet ${i + 1}</span>
            <a href="${img.url}" download="magnet-${i + 1}.png" class="ai-result-card-download" title="Download">⬇</a>
          </div>
        `;
      } else {
        card.innerHTML = `
          <div class="ai-result-card-img-wrap ai-result-card-error">
            <span>⚠️</span><p>Generation failed</p>
          </div>
          <div class="ai-result-card-footer">
            <span class="ai-result-card-label">Magnet ${i + 1}</span>
          </div>
        `;
      }

      resultsGrid.appendChild(card);
    });
  }

  if (tryAgainBtn) {
    tryAgainBtn.addEventListener('click', () => {
      selectedFiles = [];
      generatedImages = [];
      renderPreviews();
      updateProgress();
      updateGenerateBtn();
      if (resultEl) resultEl.classList.remove('active');
      hideError();
      if (uploadZone) window.scrollTo({ top: uploadZone.offsetTop - 80, behavior: 'smooth' });
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async () => {
      if (!selectedVariantId) { showError('No product variant selected.'); return; }

      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding to Cart...';
      addToCartBtn.disabled = true;

      const preset = PRESETS[selectedPreset] || PRESETS.watercolor;
      const properties = { 'Style': preset.label, 'Magnets': selectedCount.toString() };
      generatedImages.filter(img => img.success).forEach((img, i) => {
        properties[`Magnet ${i + 1} Art`] = img.url;
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(selectedVariantId), quantity: 1, properties })
        });

        if (response.ok) {
          addToCartBtn.textContent = 'Added! ✓';
          setTimeout(() => { window.location.href = '/cart'; }, 800);
        } else {
          const err = await response.json();
          throw new Error(err.description || 'Could not add to cart.');
        }
      } catch (err) {
        addToCartBtn.textContent = originalText;
        addToCartBtn.disabled = false;
        showError(err.message || 'Could not add to cart. Please try again.');
      }
    });
  }

  function buildCreditModal(variantId, priceText) {
    const overlay = document.createElement('div');
    overlay.className = 'ai-modal-overlay';
    overlay.innerHTML = `
      <div class="ai-modal-card" role="dialog" aria-modal="true">
        <div class="ai-modal-icon">✨</div>
        <h3 class="ai-modal-title">Get a new generation credit</h3>
        <p class="ai-modal-desc">Once payment is complete your credit resets automatically — no waiting, no manual steps. Then come back here and generate fresh designs with new photos.</p>
        <div class="ai-modal-price">${priceText}</div>
        <button class="ai-btn-primary ai-btn-large ai-modal-confirm">Buy Now</button>
        <button class="ai-modal-cancel">Cancel</button>
      </div>
    `;

    const confirmBtn = overlay.querySelector('.ai-modal-confirm');
    const cancelBtn = overlay.querySelector('.ai-modal-cancel');

    function closeModal() {
      overlay.classList.remove('ai-modal-overlay--visible');
      setTimeout(() => overlay.remove(), 200);
    }

    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });
    cancelBtn.addEventListener('click', closeModal);

    confirmBtn.addEventListener('click', async () => {
      confirmBtn.textContent = 'Processing...';
      confirmBtn.disabled = true;
      cancelBtn.style.display = 'none';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        if (res.ok) {
          confirmBtn.textContent = 'Redirecting to checkout...';
          setTimeout(() => { window.location.href = '/checkout'; }, 400);
        } else {
          const err = await res.json();
          throw new Error(err.description || 'Could not process. Please try again.');
        }
      } catch (err) {
        confirmBtn.textContent = 'Buy Now';
        confirmBtn.disabled = false;
        cancelBtn.style.display = '';
        showError(err.message || 'Could not process. Please try again.');
        closeModal();
      }
    });

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('ai-modal-overlay--visible'));
  }

  const buyCreditBtn = document.getElementById('ai-buy-credit-btn');
  if (buyCreditBtn) {
    buyCreditBtn.addEventListener('click', () => {
      const variantId = buyCreditBtn.dataset.creditVariant || CREDIT_VARIANT_ID;
      if (!variantId) { showError('Credit product not configured.'); return; }
      const priceText = buyCreditBtn.textContent.trim();
      buildCreditModal(variantId, priceText);
    });
  }

  updateUploadUI();
  updateGenerateBtn();
  initSession();
})();